export default __webpack_public_path__ + "static/media/login-carousel-2.0d4d7875.png";